// Translation: Account > Settings > Phone number (English)
export default Object.freeze({
	form: {
		actions: {
			save: 'Save and verify phone number',
			update: 'Update and verify phone number'
		},
		fields: {
			phoneNumber: {
				promotion: {
					message: 'Verify your number now and receive $5 worth of free credits.',
					note: 'Expires 1 month after verification'
				}
			}
		}
	},
	header: {
		title: 'Phone number'
	}
})
